import { GetLinks } from "../../../config";

export default [
  {
    key: "/application-log",
    icon: (
      <i className="ki-duotone ki-chart-pie-simple fs-1">
        <span className="path1" />
        <span className="path2" />
      </i>
    ),
    label: GetLinks("/application-log", "Application Log"),
  },
];
